// removed by extract-text-webpack-plugin
module.exports = {"clearfix":"PageLayout__clearfix___1sc4c","imageCont":"PageLayout__imageCont___9UzVd","image":"PageLayout__image___1NkZ3","body":"PageLayout__body___2KrzW PageLayout__clearfix___1sc4c","videoCont":"PageLayout__videoCont___nnliB","videoInner":"PageLayout__videoInner___FlpGr","widthWrapper":"PageLayout__widthWrapper___tkrVa"};


//////////////////
// WEBPACK FOOTER
// ./src/Rist/modules/PageLayout/PageLayout.css
// module id = 749
// module chunks = 0